import type { WorkshopRegistration } from "../types";

export function parseWorkshopSessionCost(value: string) {
  const normalized = value.trim();
  if (!/^\d+$/.test(normalized)) return undefined;
  const parsed = Number(normalized);
  return Number.isInteger(parsed) && parsed >= 1 && parsed <= 100 ? parsed : undefined;
}

export function workshopRegistrationLabel(registration: WorkshopRegistration) {
  if (registration.isLegacy) return "Eski kayıt · paket hareketi yok";
  if (registration.participationStatusCode === "CANCELLED_BY_STUDIO") {
    return "Stüdyo tarafından iptal edildi";
  }
  return "Kayıtlı";
}
